import PdpDropdownModal from './PdpDropdownModal';
import PdpDropdownGroupModal from './PdpDropdownGroupModal';
export default class PdpAccordion extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            singleValue: [],
            selectedModifierIdValue: -1,
            checked: false,
            DropdownDetails: {
                DropDownEntries: [],
                DropDownName: ''
            },
            multiSelect: this.props.accordionList || [],
            multiSelectLabels: [],
            singleTempSelectIds: [],
            originalIds: [],
            multiTempSelectIds: [],
            calText: "",
            //DefaultModifierImage: this.props.data.DefaultModifierImage || "https://qa2.applebees.com/-/media/Applebees2/Images/Menu/Default%20Images/Modifier-Placeholder?la=en&hash=89A5226BCA63C6735C23124399CA6638"
            DefaultModifierImage: this.props.data.DefaultModifierImage
        };

        this.handleMultiChange = this.handleMultiChange.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.handleClickState = this.handleClickState.bind(this);
        this.getCalorieText = this.getCalorieText.bind(this);
        this.filterDropDownInOption = this.filterDropDownInOption.bind(this);
        this.filterDropDownInOptionGroup = this.filterDropDownInOptionGroup.bind(this);
        this.holdTempSelectedIds = this.holdTempSelectedIds.bind(this);
        this.holdTempSelectedIdsDropDownGroup = this.holdTempSelectedIdsDropDownGroup.bind(this);
        this.handleSingleChange = this.handleSingleChange.bind(this);
        this.handleImageError = this.handleImageError.bind(this);

    }

    getSubstituteOptionGroupName(optionGroups) {
        let name;
        if (optionGroups.length > 0) {
            name = optionGroups[0].GroupedName;
        }
        return name;
    }
    handleImageError(e) {
        e.target.onerror = null
        e.persist();
        e.target.src = this.state.DefaultModifierImage
    }
    getTileClass(modifier) {
        let tileClass = "accordion-body " + modifier.MenuItemDetail.Id;
        if (modifier.ComponentDisplay == 7) {
            tileClass = "accordion-body substitute-body " + modifier.MenuItemDetail.Id;
            if ((this.props.idMaps && (!this.props.selectedMap.has(modifier.MenuItemDetail.Id))) ||
                (this.props.idMaps && this.props.idMaps.has(modifier.MenuItemDetail.Id) && (this.props.idMaps.get(modifier.MenuItemDetail.Id).length > 1))) {
                tileClass = "accordion-body substitute-body highlighter " + modifier.MenuItemDetail.Id;
            }

        } else if (modifier.ComponentDisplay == 5 && modifier.OptionDisplayStyle == "segmented") {
            tileClass = "accordion-body customize-body " + modifier.MenuItemDetail.Id;
            if ((modifier.optionGroups[0] != undefined) && (this.checkItemIsAdded(modifier.optionGroups[0].Modifiers, "Remove") != true)) {
                tileClass = "accordion-body customize-body highlighter " + modifier.MenuItemDetail.Id;
            }

        } else if (modifier.ComponentDisplay == 1) {
            tileClass = "accordion-body customize-body " + modifier.MenuItemDetail.Id;
            if ((this.props.idMaps.has(modifier.MenuItemDetail.Id) || this.state.multiSelect.indexOf(modifier.MenuItemDetail.Id) > -1)) {
                tileClass = "accordion-body customize-body highlighter " + modifier.MenuItemDetail.Id;
            }
        } else if (modifier.ComponentDisplay != 8) {
            if ((this.props.idMaps && this.props.idMaps.has(modifier.MenuItemDetail.Id) && (this.props.idMaps.get(modifier.MenuItemDetail.Id).length > 0))
                || this.state.multiSelect.indexOf(modifier.MenuItemDetail.Id) > -1) {
                tileClass = "accordion-body highlighter " + modifier.MenuItemDetail.Id;

            }
        } else {
            if (!this.props.idMaps.has(modifier.MenuItemDetail.Id)) {
                tileClass = "accordion-body highlighter " + modifier.MenuItemDetail.Id;

            }
        }
        if (modifier.ComponentDisplay == 4 || modifier.ComponentDisplay == 2) {
            tileClass = tileClass + " cur";
        }
        tileClass = tileClass + " comp-" + modifier.ComponentDisplay;

        return tileClass;
    }
    handleTileClick(modifier, ModifierGroup) {
        if (ModifierGroup.maxselects == 1) {
            let PerivousSelectedID = this.props.parentGrpToCountMap.get(ModifierGroup.Id);
            if (PerivousSelectedID != undefined && PerivousSelectedID.length > 0) {
                if (modifier.MenuItemDetail.Id != PerivousSelectedID[0]) {
                    $(".PdpAccordionWrapper .accordion-body." + PerivousSelectedID[0]).click();
                }
            }
        }
        if (modifier.ComponentDisplay == 7) {
            this.handleMultiChange(modifier.MenuItemDetail.Id, modifier.MenuItemDetail.Name, ModifierGroup.maxselects, ModifierGroup.Id, ModifierGroup.IsRequired, modifier.MenuItemDetail.Price, true, modifier.MenuItemDetail.BaseCalories, modifier.MenuItemDetail.CalcPrice, modifier.MenuItemDetail.ImagePath, modifier.ComponentDisplay)
        } else if (modifier.ComponentDisplay == 1) {
            this.handleMultiChange(modifier.MenuItemDetail.Id, modifier.MenuItemDetail.Name, ModifierGroup.maxselects, ModifierGroup.Id, ModifierGroup.IsRequired, modifier.MenuItemDetail.Price, false, modifier.MenuItemDetail.BaseCalories, modifier.MenuItemDetail.CalcPrice, modifier.MenuItemDetail.ImagePath, modifier.ComponentDisplay)
        } else if (modifier.ComponentDisplay == 5 && modifier.OptionDisplayStyle == "segmented") {
            this.handleSegmented(modifier.MenuItemDetail.Id, modifier.MenuItemDetail.Name, ModifierGroup.maxselects, ModifierGroup.Id, ModifierGroup.IsRequired, modifier.MenuItemDetail.Price, modifier.optionGroups[0] != undefined && modifier.optionGroups[0].Modifiers, "Remove", modifier.MenuItemDetail.BaseCalories, modifier.MenuItemDetail.CalcPrice, modifier.ComponentDisplay)
        } else if (modifier.ComponentDisplay == 0 || modifier.ComponentDisplay == 3 || modifier.ComponentDisplay == 8) {
            this.handleMultiChange(modifier.MenuItemDetail.Id, modifier.MenuItemDetail.Name, ModifierGroup.maxselects, ModifierGroup.Id, ModifierGroup.IsRequired, modifier.MenuItemDetail.Price, false, modifier.MenuItemDetail.BaseCalories, modifier.MenuItemDetail.CalcPrice, modifier.MenuItemDetail.ImagePath, modifier.ComponentDisplay);
        } else if (modifier.ComponentDisplay == 6) {
            if (this.props.idMaps && this.props.idMaps.has(modifier.MenuItemDetail.Id) && (this.props.idMaps.get(modifier.MenuItemDetail.Id).length > 0)) {
                this.handleHighlightState(modifier.MenuItemDetail.Id, modifier.MenuItemDetail.Price, modifier.ComponentDisplay)
            } else {
                this.handleMultiChange(modifier.MenuItemDetail.Id, modifier.MenuItemDetail.Name, ModifierGroup.maxselects, ModifierGroup.Id, ModifierGroup.IsRequired, modifier.MenuItemDetail.Price, false, modifier.MenuItemDetail.BaseCalories, modifier.MenuItemDetail.CalcPrice, modifier.MenuItemDetail.ImagePath, modifier.ComponentDisplay);
            }
        } else if (modifier.ComponentDisplay == 4) {
            if (this.props.idMaps && this.props.idMaps.has(modifier.MenuItemDetail.Id) && (this.props.idMaps.get(modifier.MenuItemDetail.Id).length > 0)) {
                this.handleUnselect(modifier.MenuItemDetail.Id, ModifierGroup.maxselects, ModifierGroup.Id, ModifierGroup.IsRequired, modifier.MenuItemDetail.Price)
            } else {
                this.handleMultiChange(modifier.MenuItemDetail.Id, modifier.MenuItemDetail.Name, ModifierGroup.maxselects, ModifierGroup.Id, ModifierGroup.IsRequired, modifier.MenuItemDetail.Price, false, modifier.MenuItemDetail.BaseCalories, modifier.MenuItemDetail.CalcPrice, modifier.MenuItemDetail.ImagePath, modifier.ComponentDisplay);
                this.props.handleClick(modifier.MenuItemDetail.Name, modifier.MenuItemDetail.Id, ModifierGroup.IsRequired, modifier, ModifierGroup.Id);
            }
        } else if (modifier.ComponentDisplay == 2) {
            if (this.props.idMaps && this.props.idMaps.has(modifier.MenuItemDetail.Id) && (this.props.idMaps.get(modifier.MenuItemDetail.Id).length > 0)) {
                this.handleUnselect(modifier.MenuItemDetail.Id, ModifierGroup.maxselects, ModifierGroup.Id, ModifierGroup.IsRequired, modifier.MenuItemDetail.Price)
            } else {
                this.handleMultiChange(modifier.MenuItemDetail.Id, modifier.MenuItemDetail.Name, ModifierGroup.maxselects, ModifierGroup.Id, ModifierGroup.IsRequired, modifier.MenuItemDetail.Price, false, modifier.MenuItemDetail.BaseCalories, modifier.MenuItemDetail.CalcPrice, modifier.MenuItemDetail.ImagePath, modifier.ComponentDisplay);
                this.props.handleClick(modifier.MenuItemDetail.Name, modifier.MenuItemDetail.Id, ModifierGroup.IsRequired, modifier, ModifierGroup.Id);
            }
        } else {
            this.handleHighlightState(modifier.MenuItemDetail.Id, modifier.MenuItemDetail.Price, modifier.ComponentDisplay)
        }

    }
    getTileName(MenuItemDetail, ComponentDisplay) {
        let names = [];
        let name = (ComponentDisplay != 8 && ComponentDisplay != 7) ? MenuItemDetail.Name : MenuItemDetail.ModifierSlugName;
        names.push(name);
        if (ComponentDisplay == 6) {
            if (this.props.idMaps && this.props.idMaps.has(MenuItemDetail.Id) && (this.props.idMaps.get(MenuItemDetail.Id).length > 1)) {
                names = [];
            }
        }
        else if (ComponentDisplay == 4 || ComponentDisplay == 7) {
            if (this.props.idMaps && this.props.idMaps.has(MenuItemDetail.Id) && (this.props.idMaps.get(MenuItemDetail.Id).length > 1)) {
                names = [];
                this.props.idMaps.get(MenuItemDetail.Id).map((label, index) => {
                    if (label.id != MenuItemDetail.Id && label.order != 2) {
                        names.push(label.name)
                    }
                })
            }
        }

        return names.join(',');

    }
    getTileDescription(Id, name, componentDisplay) {
        let names = [];
        if ( componentDisplay == 6 || componentDisplay == 2 || componentDisplay == 3) {
            if (this.props.idMaps && this.props.idMaps.has(Id) && (this.props.idMaps.get(Id).length > 1)) {
                 this.props.idMaps.get(Id).map((label, index) => {
                     if (label.id != Id) {
                         names.push(label.name);
                     }
                })
            }
        } else if (componentDisplay == 7 || componentDisplay == 4) {
            if (this.props.idMaps && this.props.idMaps.has(Id) && (this.props.idMaps.get(Id).length > 1)) {
               this.props.idMaps.get(Id).map((label, index) => {
                   if (label.id != Id && label.order == 2) {
                       names.push(label.name);
                   }
                })
            }
        }
        else if (componentDisplay == 1) {
            if (this.props.idMaps && this.props.idMaps.has(Id)) {
                this.props.idMaps.get(Id).map((label, index) => {
                    if (label.id != Id) {
                        names.push(label.name);
                    }
                })
            }
        } else if (componentDisplay == 0 || componentDisplay == 8) {
            names = [];
        } else {
            if (this.props.idMaps && this.props.idMaps.has(Id)) {
                this.props.idMaps.get(Id).map((label, index) => {
                    names.push(label.name);
                })
            }
        }

        return names.join(',');

    }
    getReqiuredStatus(ModifierGroup) {
        let returnText = "optional";
        let className = "";
        let count = 0, selectedChildCount = 0;
        if (ModifierGroup.IsRequired == true) {
            returnText = "Required";

            ModifierGroup.Modifiers.map((modifier) => {
                let parentId = (ModifierGroup.GroupDisplay == 0) ? modifier.MenuItemDetail.Id : ModifierGroup.Id;
                if (this.props.idMaps && this.props.idMaps.has(parentId)) {
                    let data = this.props.idMaps.get(parentId);
                    if (data.length > 0) {
                        data.map(item => {
                            if ($(".accordion-body." + item.id).hasClass("comp-3") != true) {
                                count++;
                            }
                        })
                    }


                }
            });




            if (ModifierGroup.IsRequired == true && count >= ModifierGroup.minselects) {
                returnText = "completed";
                className = "showBold completed";
            }
        }
        let resp = {
            "text": returnText,
            "className": className
        }

        return resp;
    }

    getCumulatePriceAndCalories(id, price, baseCal, isSubstitute, componentDisplayId) {
        let count = 0, cm = baseCal, totalprice = price, toggle = false;
        if (componentDisplayId == 8) {
            if (this.props.idMaps && !this.props.idMaps.has(id)) {
                baseCal = 0;
            } else {
                toggle = true;
            }

        }
        else if (componentDisplayId == 2) {
            if (this.props.idMaps && this.props.idMaps.has(id) && this.props.idMaps.get(id).length > 0) {
                this.props.idMaps.get(id).map(menu => {
                    if (menu.id != id) {
                        totalprice = totalprice + menu.price;
                    }

                })
            }

        }
        else if (componentDisplayId != 0) {
            if (isSubstitute == true && this.props.idMaps && this.props.idMaps.has(id) && this.props.idMaps.get(id).length > 1) {
                count = 1;
                cm = 0;
                totalprice = 0;
            }
            if (isSubstitute == true && this.props.idMaps && (!this.props.idMaps.has(id) || this.props.idMaps.get(id).length == 0)) {
                baseCal = 0;
                totalprice = 0;
            }
            if (isSubstitute == false && this.props.idMaps && this.props.idMaps.has(id) && this.props.idMaps.get(id).length > 0) {
                count = 1;
                cm = 0;
                // totalprice = price;
            }

            if (count == 1) {
                this.props.idMaps.get(id).map(menu => {
                    if (menu.id != id && menu.baseCal != null) {
                        cm = parseInt(cm) + parseInt(menu.baseCal);
                    }
                    if (menu.id != id) {
                        totalprice = totalprice + menu.price;
                    }

                })
                baseCal = cm;
            }
        }


        let res = (baseCal > 0 ? this.props.CalorieAdds + " " + baseCal :
            (baseCal < 0 ? this.props.CalorieSubtracts + " " + (-1 * baseCal) : "0")) + " " + this.props.CalorieAbbr;
        let calcPrice = totalprice;
        totalprice = "$" + parseFloat(totalprice).toFixed(2);
        return {
            "calories": res,
            "caloriesInNum": (toggle == true) ? true : baseCal,
            "price": totalprice,
            "calcPrice": calcPrice
        };
    }


    handleMultiChange(selectedModifierId, label, max, parentId, reqdStatus, price, isSubstitute, baseCal, CalcPrice, image, componentDisplay) {
        let arr = this.state.multiSelect;
        let cnt = 0;
        const hierarchyData = [];

        let labelDisplay = {
            "id": selectedModifierId,
            "name": label,
            "baseCal": baseCal,
            "price": CalcPrice,
            "image": image,
            "componentDisplay": componentDisplay
        }
        let multiselectDisplayLabel = [];
        let indexExist = -1;
        /*this.props.selectedSubItems.map((keyStr, indx) => {
            let id = keyStr.id;
            if (id == labelDisplay.id) {
                indexExist = indx;
            }
        });*/
        indexExist = arr.indexOf(selectedModifierId);
        if (indexExist <= -1) {
            if (this.props.checkMaxCount(selectedModifierId, max, parentId, 'add')) {
                cnt = 1;
                this.props.selectedSubItems.push(labelDisplay)
                arr.push(selectedModifierId);
                multiselectDisplayLabel.push(label);
                let selectItem = {};
                selectItem.value = selectedModifierId;
                selectItem.label = label;
                selectItem.baseCal = baseCal;
                selectItem.price = CalcPrice;
                selectItem.image = image;
                selectItem.componentDisplay = componentDisplay;

                selectItem.parentModifierId = selectedModifierId;
                selectItem.parentGroupId = selectedModifierId;

                this.props.setSelectedModifiersList(selectItem, selectedModifierId);
                //this.props.selectedMap.set(selectedModifierId, this.props.selectedSubItems);
                let data = {
                    "id": selectedModifierId,
                    "name": label,
                    "baseCal": baseCal,
                    "price": CalcPrice,
                    "image": image,
                    "componentDisplay": componentDisplay
                }
                hierarchyData.push(data);
                this.props.idMaps.set(selectedModifierId, hierarchyData);
                this.props.selectedMap.set(selectedModifierId, hierarchyData);
                this.props.updateTotalPrice(price, "add", selectedModifierId);


            }
        } else {
            cnt = 1;
            if (this.props.idMaps && this.props.idMaps.has(selectedModifierId) && (this.props.idMaps.get(selectedModifierId).length > 1)) {
                // has substitute
                let removeIds = [];
                this.props.idMaps.get(selectedModifierId).map((label, index) => {
                    if (label.id != selectedModifierId) {
                        removeIds.push(label.id);
                        multiselectDisplayLabel.splice(multiselectDisplayLabel.indexOf(label.name), 1);
                    }
                });

                removeIds.map((removeId) => {
                    arr.splice(arr.indexOf(removeId), 1);
                    this.props.removeselectedSubItems(removeId);
                    this.props.removeSelectedModifiersList({ value: removeId }, null, selectedModifierId);
                    let childparentId = this.props.getParentIdByValue(removeId);
                    this.props.checkMaxCount(removeId, max, childparentId, 'remove', 'single');
                    this.props.updateTotalPrice(price, "child", removeId);
                    // Since we are pushing selectedsubitems into the selected map, no need to delete separately
                    this.props.removeSelectedMap(removeId, selectedModifierId);
                    this.props.removeidMap(removeId, selectedModifierId);

                });

            } else {
                if (isSubstitute == true) {
                    this.props.removeselectedSubItems(selectedModifierId);
                    this.props.selectedMap.delete(selectedModifierId);
                    this.props.idMaps.delete(selectedModifierId);
                    arr.splice(arr.indexOf(selectedModifierId), 1);
                    this.props.checkMaxCount(selectedModifierId, max, parentId, 'remove', 'single');
                    this.props.updateTotalPrice(price, "remove", selectedModifierId);
                    this.props.removeSelectedModifiersList({ value: selectedModifierId }, "all");
                }
            }
            if (isSubstitute != true) {
                this.props.removeselectedSubItems(selectedModifierId);
                this.props.selectedMap.delete(selectedModifierId);
                this.props.idMaps.delete(selectedModifierId);
                arr.splice(arr.indexOf(selectedModifierId), 1);
                this.props.checkMaxCount(selectedModifierId, max, parentId, 'remove', 'single');
                this.props.updateTotalPrice(price, "remove", selectedModifierId);
                this.props.removeSelectedModifiersList({ value: selectedModifierId }, "all");
            }

        }
        if (cnt == 1) {

            this.setState({ multiSelect: arr }, () => {
                //console.log(this.state.multiSelect, 'multiSelect');
            });

            this.setState({ multiSelectLabels: multiselectDisplayLabel }, () => {
                //console.log(this.state.multiSelectLabels, 'multiSelectLabels');
            });

            this.props.handleModalSelectedIds(this.state.multiSelect);
        } else {
            $(".pdp-error-display.alert-dismissible").removeClass("hidden").show().children('.alert-message').text(this.props.data.MaxSelection);
            $(".pdp-error-display.alert-dismissible")[0].scrollIntoView();
        }
    }


    handleClick(title, selectedMenuId, isRequired, modifiers, max, parentId) {
        if (selectedMenuId != this.state.selectedModifierIdValue) {
            if (this.props.checkMaxCount(selectedMenuId, max, parentId, 'add', 'multi')) {
                //console.log(this.state.multiSelect, 'multiSelect');
                this.props.handleClick(title, selectedMenuId, isRequired, modifiers, parentId);
            } else {
                $(".pdp-error-display.alert-dismissible").removeClass("hidden").show().children('.alert-message').text(this.props.data.MaxSelection);
                $(".pdp-error-display.alert-dismissible")[0].scrollIntoView();
            }

        }
    }

    handleClickState(index, modifier, modifierGroup) {
        let showDisplaEle = document.getElementById(index + "-checkClick");
        let hasHighlighter = $(".accordion-body." + index).hasClass("highlighter");
        if (showDisplaEle.classList.contains('firstClick') || hasHighlighter == true) {
            if (this.props.checkMaxCount(index, modifierGroup.maxselects, modifierGroup.Id, 'add', 'multi')) {
                let title = modifier.MenuItemDetail.Name;
                if (modifier.ComponentDisplay == 7 || modifier.ComponentDisplay == 6) {
                    title = this.getSubstituteOptionGroupName(modifier.optionGroups);
                }

                if (modifier.ComponentDisplay == 6) {
                    let existArray = this.props.idMaps.get(modifier.MenuItemDetail.Id) || [];
                    if (existArray.length == 0) {
                        let labelDisplay = {
                            "id": modifier.MenuItemDetail.Id,
                            "name": modifier.MenuItemDetail.Name,
                            "baseCal": modifier.MenuItemDetail.BaseCalories,
                            "price": modifier.MenuItemDetail.CalcPrice,
                            "componentDisplay": modifier.ComponentDisplay

                        }
                        this.props.idMaps.set(modifier.MenuItemDetail.Id, [labelDisplay]);
                        this.props.selectedMap.set(modifier.MenuItemDetail.Id, [labelDisplay]);

                        let selectItem = {};
                        selectItem.value = modifier.MenuItemDetail.Id;
                        selectItem.label = modifier.MenuItemDetail.Name;
                        selectItem.baseCal = modifier.MenuItemDetail.BaseCalories;
                        selectItem.price = modifier.MenuItemDetail.CalcPrice;
                        selectItem.componentDisplay = modifier.ComponentDisplay;
                        selectItem.parentModifierId = modifier.MenuItemDetail.Id;
                        selectItem.parentGroupId = modifier.MenuItemDetail.Id;
                        this.props.setSelectedModifiersList(selectItem, modifier.MenuItemDetail.Id);
                    }
                }


                this.handleClick(title, index, modifierGroup.IsRequired, modifier, modifierGroup.maxselects, modifierGroup.Id);

            } else {
                $(".pdp-error-display.alert-dismissible").removeClass("hidden").show().children('.alert-message').text(this.props.data.MaxSelection);
                $(".pdp-error-display.alert-dismissible")[0].scrollIntoView();
            }
        }
    }



    //componentdisplay 2
    handleUnselect(selectedModifierId, max, parentId, reqdStatus, price) {
        let arr = this.state.multiSelect;
        // let multiselectDisplayLabels = this.state.multiselectDisplayLabels;
        if (this.props.selectedMap.get(selectedModifierId)) {
            if (this.props.idMaps && this.props.idMaps.has(selectedModifierId) && (this.props.idMaps.get(selectedModifierId).length > 0)) {
                let removeIds = [];
                this.props.idMaps.get(selectedModifierId).map((label, index) => {
                    if (label.id != selectedModifierId) {
                        removeIds.push(label.id);
                    }
                });
                removeIds.map((removeId) => {
                    arr.splice(arr.indexOf(removeId), 1);
                    this.props.removeselectedSubItems(removeId);
                    this.props.removeSelectedModifiersList({ value: removeId }, null, selectedModifierId);
                    let childparentId = this.props.getParentIdByValue(removeId);
                    this.props.checkMaxCount(removeId, max, childparentId, 'remove', 'single');
                    this.props.updateTotalPrice(price, "child", removeId);
                    // Since we are pushing selectedsubitems into the selected map, no need to delete separately
                    this.props.removeSelectedMap(removeId, selectedModifierId);
                    this.props.removeidMap(removeId, selectedModifierId);
                });

            }
            this.props.removeselectedSubItems(selectedModifierId);
            this.props.selectedMap.delete(selectedModifierId);
            this.props.idMaps.delete(selectedModifierId);
            arr.splice(arr.indexOf(selectedModifierId), 1);
            this.props.checkMaxCount(selectedModifierId, max, parentId, 'remove', 'single');
            this.props.updateTotalPrice(price, "remove", selectedModifierId);
            this.props.removeSelectedModifiersList({ value: selectedModifierId }, "all");

            this.setState({ multiSelect: arr }, () => {
                //console.log(this.state.multiSelect, 'multiSelect');
            });
        }
        this.props.handleModalSelectedIds(this.state.multiSelect);
    }

    handleHighlightState(index, price, componentID) {
        // No action when side item is already selected
        if (componentID && componentID == 6) {
            if (this.props.idMaps && this.props.idMaps.has(index)) {
                let getData = this.props.idMaps.get(index);
                if (getData.length > 0) {
                    return false;
                }
            }
        }
        let showDisplaEle = document.getElementById(index + "-checkClick");
        if (showDisplaEle != null) {
            if (showDisplaEle.classList.contains('firstClick')) {
                showDisplaEle.classList.remove("show");
                showDisplaEle.classList.add("hideCheckClick");
                showDisplaEle.classList.remove("firstClick");
                // document.getElementById(index + "-checkClick").parentElement.parentElement.parentElement.classList.remove("selectedDiv");
                document.getElementById(index + "-checkClick").parentElement.parentElement.parentElement.classList.remove("highlighter");
                if (price) this.props.updateTotalPrice(price, "remove", index);

            } else {
                showDisplaEle.classList.add("show");
                showDisplaEle.classList.remove("hideCheckClick");
                showDisplaEle.classList.add("firstClick");
                document.getElementById(index + "-checkClick").parentElement.parentElement.parentElement.classList.add("highlighter");
                if (price) this.props.updateTotalPrice(price, "add", index);

            }
        }
    }
    holdTempSelectedIds(type, obj, ids) {
        this.state.originalIds = ids;
        this.handleSingleChange(obj);
    }
    holdTempSelectedIdsDropDownGroup(type, obj, ids) {
        this.state.originalIds = ids;
        //this.state.isDropDownSelectionCompleted = isDropDownSelectionCompleted;
        this.handleSingleChange(obj);
    }
    handleSingleChange(obj) {
        let selectedModifierId = obj.parentModifierId;
        let labelDisplay = {
            "id": obj.value,
            "name": obj.label,
            "baseCal": obj.baseCal,
            "price": obj.price,
            "componentDisplay": obj.componentDisplay

        }
        let arrSingle = this.state.multiSelect;
        let removeObj;

        // Rmeove Existing selection of the dropdown
        this.props.selectedSubItems.map((keyStr, indx) => {
            let id = keyStr.id/*.split("-")[0]*/
            if (this.state.originalIds.indexOf(id) > -1 && id != obj.value) {
                removeObj = keyStr;
            }
        });

        if (removeObj && removeObj.id) {
            let x = arrSingle.indexOf(removeObj.id);
            if (x > -1) {
                arrSingle.splice(arrSingle.indexOf(removeObj.id), 1);
                this.props.removeSelectedModifiersList({ value: removeObj.id }, null, selectedModifierId);
                this.props.updateselectedSubItems(removeObj);
                this.props.removeidMap(removeObj.id, selectedModifierId);
                this.props.removeSelectedMap(removeObj.id, selectedModifierId);
            }
        }

        let indexExist = this.props.updateselectedSubItems(labelDisplay, "getindex");
        if (indexExist == -1) {
            this.props.updateselectedSubItems(labelDisplay, "add");
            this.props.setSelectedModifiersList(obj, selectedModifierId);
            arrSingle.push(obj.value);

            let data = this.props.idMaps.get(selectedModifierId) || [];
            data.push(labelDisplay);
            this.props.idMaps.set(selectedModifierId, data);
            this.props.selectedMap.set(selectedModifierId, data);
        }


        this.setState({ multiSelect: arrSingle }, () => {
            //console.log(this.state.multiSelect, 'DropdownSelectIds333');
        });


        this.props.handleModalSelectedIds(this.state.multiSelect);
    }
    checkItemIsAdded(modifiers, type) {
        let removeOptionItem;
        let arr = this.state.multiSelect;

        if ((type == "Remove" || type == "Extra") && modifiers != undefined && modifiers != false) {
            modifiers.map(modifier => {
                if (modifier.MenuItemDetail.Name == type) {
                    removeOptionItem = modifier;
                }
            })
            if (arr.indexOf(removeOptionItem.MenuItemDetail.Id) > -1) {
                return true;
            }
        }

        return false;
    }
    getExtraPrice(modifiers) {
        if (modifiers != undefined) {
            let price;
            modifiers.map(modifier => {
                if (modifier.MenuItemDetail.Name == "Extra") {
                    price = modifier.MenuItemDetail.Price;
                }
            });
            return price;
        }
    }

    handleSegmented(selectedModifierId, label, max, parentId, reqdStatus, price, modifiers, type, baseCal, calcPrice, componentDisplay) {
        let arr = this.state.multiSelect;
        let cnt = 0;
        const hierarchyData = [];
        let labelDisplay = {
            "id": selectedModifierId,
            "name": label,
            "baseCal": baseCal,
            "price": calcPrice,
            "componentDisplay": componentDisplay

        }
        let multiselectDisplayLabel = [];
        let indexExist = -1;
        /*this.props.selectedSubItems.map((keyStr, indx) => {
            let id = keyStr.id*//*.split("-")[0]*//*
    if (id == labelDisplay.id) {
        indexExist = indx;
    }
});*/
        indexExist = arr.indexOf(selectedModifierId);

        let extraAlreadySelected = false;
        // Extra is already selected and without unselect when user try to remove
        if ((indexExist != -1 && modifiers != undefined && this.checkItemIsAdded(modifiers, "Remove") != true && type == "Remove")) {
            extraAlreadySelected = true;
            modifiers.map(modifier => {
                if (modifier.MenuItemDetail.Name == "Extra") {
                    this.props.removeselectedSubItems(modifier.MenuItemDetail.Id);
                    this.props.removeSelectedModifiersList({ "value": selectedModifierId }, "all");
                    this.props.updateTotalPrice(modifier.MenuItemDetail.Price, "remove", modifier.MenuItemDetail.Id);
                    arr.splice(arr.indexOf(modifier.MenuItemDetail.Id), 1);
                }
            })
            this.props.removeselectedSubItems(selectedModifierId);
            this.props.selectedMap.delete(selectedModifierId);
            this.props.idMaps.delete(selectedModifierId);
            arr.splice(arr.indexOf(selectedModifierId), 1);
            this.props.checkMaxCount(selectedModifierId, max, parentId, 'remove', 'single');
            this.props.updateTotalPrice(price, "remove", selectedModifierId);
            this.props.removeSelectedModifiersList({ value: selectedModifierId }, "all");
        }

        if (indexExist <= -1 || extraAlreadySelected == true) {
            if (this.props.checkMaxCount(selectedModifierId, max, parentId, 'add')) {
                cnt = 1;
                this.props.selectedSubItems.push(labelDisplay)
                arr.push(selectedModifierId);
                multiselectDisplayLabel.push(label);
                let selectItem = {};
                selectItem.value = selectedModifierId;
                selectItem.label = label;
                selectItem.baseCal = baseCal;
                selectItem.price = calcPrice;
                selectItem.componentDisplay = componentDisplay;
                selectItem.parentModifierId = selectedModifierId;
                selectItem.parentGroupId = selectedModifierId;

                this.props.setSelectedModifiersList(selectItem, selectedModifierId);

                this.props.selectedMap.set(selectedModifierId, [labelDisplay]);
                let data = {
                    "id": selectedModifierId,
                    "name": label,
                    "baseCal": baseCal,
                    "price": calcPrice,
                    "componentDisplay": componentDisplay
                }
                hierarchyData.push(data);
                this.props.idMaps.set(selectedModifierId, hierarchyData);
                this.props.updateTotalPrice(price, "add", selectedModifierId);
                if (modifiers != undefined) {
                    let removeOptionItem;
                    modifiers.map(modifier => {
                        if (modifier.MenuItemDetail.Name == type) {
                            removeOptionItem = modifier;
                        }
                    })
                    let sublabelDisplay = {
                        "id": removeOptionItem.MenuItemDetail.Id,
                        "name": removeOptionItem.MenuItemDetail.Name,
                        "baseCal": removeOptionItem.MenuItemDetail.BaseCalories,
                        "price": removeOptionItem.MenuItemDetail.CalcPrice,
                        "componentDisplay": removeOptionItem.ComponentDisplay
                    }
                    this.props.selectedSubItems.push(sublabelDisplay)
                    arr.push(sublabelDisplay.id);
                    multiselectDisplayLabel.push(sublabelDisplay.name);
                    let selectItem = {};
                    selectItem.value = sublabelDisplay.id;
                    selectItem.label = sublabelDisplay.name;
                    selectItem.baseCal = sublabelDisplay.baseCal;
                    selectItem.price = sublabelDisplay.price;
                    selectItem.componentDisplay = sublabelDisplay.componentDisplay;
                    selectItem.parentModifierId = selectedModifierId;
                    selectItem.parentGroupId = selectedModifierId;

                    this.props.setSelectedModifiersList(selectItem);

                    let data = this.props.selectedMap.get(selectedModifierId);
                    data.push(sublabelDisplay);
                    this.props.selectedMap.set(selectedModifierId, data);

                    let hierarchyData = this.props.idMaps.get(selectedModifierId);
                    hierarchyData.push(sublabelDisplay);

                    this.props.idMaps.set(selectedModifierId, hierarchyData);
                    this.props.updateTotalPrice(removeOptionItem.MenuItemDetail.Price, "add", removeOptionItem.MenuItemDetail.Id);

                }


            }
        } else {
            cnt = 1;
            if (modifiers != undefined) {
                let removeOptionItem;
                modifiers.map(modifier => {
                    removeOptionItem = modifier;
                    if (arr.indexOf(removeOptionItem.MenuItemDetail.Id) > -1) {
                        this.props.removeselectedSubItems(removeOptionItem.MenuItemDetail.Id);
                        this.props.removeSelectedModifiersList({ value: removeOptionItem.MenuItemDetail.Id }, null, selectedModifierId);
                        arr.splice(arr.indexOf(removeOptionItem.MenuItemDetail.Id), 1);
                        this.props.updateTotalPrice(removeOptionItem.MenuItemDetail.Price, "remove", removeOptionItem.MenuItemDetail.Id);

                    }
                })

            }

            this.props.removeselectedSubItems(selectedModifierId);
            this.props.selectedMap.delete(selectedModifierId);
            this.props.idMaps.delete(selectedModifierId);
            arr.splice(arr.indexOf(selectedModifierId), 1);
            this.props.checkMaxCount(selectedModifierId, max, parentId, 'remove', 'single');
            this.props.updateTotalPrice(price, "remove", selectedModifierId);
            this.props.removeSelectedModifiersList({ value: selectedModifierId }, "all");
        }
        if (cnt == 1) {
            this.setState({ multiSelect: arr }, () => {

                //console.log(this.state.multiSelect, 'multiSelect');
            });

            this.setState({ multiSelectLabels: multiselectDisplayLabel }, () => {

                //console.log(this.state.multiSelectLabels, 'multiSelectLabels');
            });

            this.props.handleModalSelectedIds(this.state.multiSelect);
        } else {
            $(".pdp-error-display.alert-dismissible").removeClass("hidden").show().children('.alert-message').text(this.props.data.MaxSelection);
            $(".pdp-error-display.alert-dismissible")[0].scrollIntoView();
        }
    }

    filterDropDownInOption(optionGroups) {
        //console.log('optionGroups --->  ', optionGroups);
        let nextOptionGroupsInternl = [];
        let dropdownTitle = '';
        let arr = [];
        if (optionGroups.length > 0) {
            optionGroups.map(optionGroups => {

                optionGroups.Modifiers.map(optModifier => {
                    let optionvalue = {};
                    dropdownTitle = optionGroups.Name;
                    nextOptionGroupsInternl.push(optModifier);
                    optionvalue.label = optModifier.MenuItemDetail.Name;
                    optionvalue.value = optModifier.MenuItemDetail.Id;
                    optionvalue.ImagePath = optModifier.MenuItemDetail.ImagePath;
                    optionvalue.ModifierSlugName = optModifier.MenuItemDetail.ModifierSlugName;
                    optionvalue.BaseCalories = optModifier.MenuItemDetail.BaseCalories;
                    optionvalue.Price = optModifier.MenuItemDetail.Price;
                    optionvalue.CalcPrice = optModifier.MenuItemDetail.CalcPrice;
                    optionvalue.ComponentDisplay = optModifier.ComponentDisplay;
                    optionvalue.GroupDisplay = optionGroups.GroupDisplay;
                    if (this.state.multiSelect.includes(optModifier.MenuItemDetail.Id)) {
                        optionvalue.selected = "true";
                    } else {
                        optionvalue.selected = "false";
                    }
                    optModifier.optionGroups.map(optRequire => {
                        optionvalue.IsRequired = optRequire.IsRequired;
                        optionvalue.maxselects = optRequire.maxselects;
                    })
                    optionvalue.lenCheck = optModifier.optionGroups;
                    arr.push(optionvalue);
                })
            })
        }
        //this.setState({ DropdownDetails: { DropDownEntries: arr, DropDownName: dropdownTitle } });
        this.state.DropdownDetails.DropDownEntries = arr;
        this.state.DropdownDetails.DropDownName = dropdownTitle;
        ////console.log(this.state.DropdownDetails, "optionGropV");
        return true;
    }
    filterDropDownInOptionGroup(optionGroup) {
        //console.log('optionGroups --->  ', optionGroup);
        let dropdownTitle = '';
        let arr = [];
        let DropdownDetails = {
            DropDownEntries: [],
            DropDownName: ''
        }
        if (optionGroup.Modifiers.length > 0) {
            optionGroup.Modifiers.map(optModifier => {
                let optionvalue = {};
                dropdownTitle = optionGroup.Name;
                optionvalue.label = optModifier.MenuItemDetail.Name;
                optionvalue.value = optModifier.MenuItemDetail.Id;
                optionvalue.ImagePath = optModifier.MenuItemDetail.ImagePath;
                optionvalue.ModifierSlugName = optModifier.MenuItemDetail.ModifierSlugName;
                optionvalue.BaseCalories = optModifier.MenuItemDetail.BaseCalories;
                optionvalue.Price = optModifier.MenuItemDetail.Price;
                optionvalue.CalcPrice = optModifier.MenuItemDetail.CalcPrice;
                optionvalue.ComponentDisplay = optModifier.ComponentDisplay;
                optionvalue.GroupDisplay = optionGroup.GroupDisplay;
                optionvalue.DefaultFlag = optModifier.MenuItemDetail.IsDefault;
                if (this.state.multiSelect.includes(optModifier.MenuItemDetail.Id)) {
                    optionvalue.selected = "true";
                    // this.state.isDropDownSelectionCompleted = true;
                } else {
                    optionvalue.selected = "false";
                }

                optModifier.optionGroups.map(optRequire => {
                    optionvalue.IsRequired = optRequire.IsRequired;
                    optionvalue.maxselects = optRequire.maxselects;
                })
                optionvalue.lenCheck = optModifier.optionGroups;
                arr.push(optionvalue);
            })
        }

        DropdownDetails.DropDownEntries = arr;
        DropdownDetails.DropDownName = dropdownTitle;
        return DropdownDetails;
    }
    getCalorieText(BaseCalories) {
        return BaseCalories > 0 ? this.props.CalorieAdds + " " + BaseCalories :
            (BaseCalories < 0 ? this.props.CalorieSubtracts + " " + (-1 * BaseCalories) : "0")
    }

    getSideProductImage(modifier) {
        let image = modifier.MenuItemDetail.ImagePath;
        let altname = modifier.MenuItemDetail.ModifierSlugName;
        let count = 0;
        if (modifier.ComponentDisplay == 6 || modifier.ComponentDisplay == 4) {
            if (this.props.idMaps && this.props.idMaps.has(modifier.MenuItemDetail.Id)) {
                this.props.idMaps.get(modifier.MenuItemDetail.Id).map((label, index) => {
                    if (label.id != modifier.MenuItemDetail.Id && count == 0) {
                        count++;
                        image = label.image;
                        altname = label.name;
                    }
                })
            }
        }
        if (modifier.ComponentDisplay == 7) {
            if (this.props.idMaps && this.props.idMaps.has(modifier.MenuItemDetail.Id)) {
                this.props.idMaps.get(modifier.MenuItemDetail.Id).map((label, index) => {
                    if (this.props.idMaps.get(modifier.MenuItemDetail.Id).length > 1) {
                        if (label.id != modifier.MenuItemDetail.Id && count == 0) {
                            count++;
                            image = label.image;
                            altname = label.name;
                        }
                    } else {
                        if (count == 0) {
                            count++;
                            image = label.image;
                            altname = label.name;
                        }
                    }

                })
            }
        }
        //console.log(image, altname);
        return {
            "image": image,
            "altname": altname
        }
    }

    render() {
        const { multiSelect } = this.state;
        const { data } = this.props;

        return (
            <div className="PdpAccordionWrapper" >
                <div className="container-fluid">
                    <div className="row">
                        {this.props.data.ModifierGroups.map((ModifierGroup, index) => {
                            if (index >= this.props.inDex) {
                                let reqiuredText = this.getReqiuredStatus(ModifierGroup);
                                let reqClass = "optional";
                                if (ModifierGroup.IsRequired == true) reqClass = "required";

                                return (
                                    ModifierGroup.GroupDisplay == 0 ?
                                        <div className="accordion" id={"#accordion-" + ModifierGroup.Id} aria-labelledby={ModifierGroup.Name}>

                                            <div className="accordion-item">
                                                <h5 className="accordion-header">
                                                    <button className={"accordion-button " + reqClass} data-option-title={ModifierGroup.Name} type="button" aria-labelledby={ModifierGroup.Name} data-bs-toggle="collapse" data-bs-target={"#accordion-" + ModifierGroup.Id} aria-expanded="false" aria-controls={"#accordion-" + ModifierGroup.Id}>
                                                        {ModifierGroup.Name}

                                                        <p className={"p2 scroller-bar " + reqiuredText.className} data-group-name={ModifierGroup.Name}> ({reqiuredText.text})</p>



                                                    </button>
                                                </h5>
                                            </div>

                                            {ModifierGroup.Modifiers.map((modifier) => {

                                                let cumulativeData = this.getCumulatePriceAndCalories(modifier.MenuItemDetail.Id, modifier.MenuItemDetail.CalcPrice, modifier.MenuItemDetail.BaseCalories, (modifier.ComponentDisplay == 7) ? true : false, modifier.ComponentDisplay);

                                                let productSideImage = this.getSideProductImage(modifier);
                                                let extraPrice = "$0.00";
                                                if (modifier.ComponentDisplay == 5 && modifier.OptionDisplayStyle == "segmented") {
                                                    extraPrice = this.getExtraPrice(modifier.optionGroups[0].Modifiers);
                                                }

                                                return (
                                                    <div id={"accordion-" + ModifierGroup.Id} className={"accordion-collapse collapse " + modifier.ComponentDisplay} aria-labelledby={ModifierGroup.Name} data-bs-parent={"#accordion-" + ModifierGroup.Id}>
                                                        {(modifier.ComponentDisplay == 7) ?
                                                            <div className={this.getTileClass(modifier)}
                                                                onClick={() => this.handleTileClick(modifier, ModifierGroup)} tabIndex="0">

                                                                {(productSideImage.image != "none" && productSideImage.image != undefined) &&
                                                                    <img className="ModifierImg" src={productSideImage.image} alt={productSideImage.altname}
                                                                        onError={(e) => { this.handleImageError(e) }} />
                                                                }

                                                                <div className="ModifierDesc">
                                                                    <div className="leftDesc">
                                                                        <p className="p2 ellipsisText">{this.getTileName(modifier.MenuItemDetail, modifier.ComponentDisplay)}</p>

                                                                        <p className="small-text accDetail ellipsisText">
                                                                            {this.getTileDescription(modifier.MenuItemDetail.Id, "", modifier.ComponentDisplay)}
                                                                        </p>

                                                                        <p className="p2">

                                                                            {(cumulativeData.calcPrice != 0) && <span className="addPrice small-text">+ {cumulativeData.price}</span>}
                                                                            {((cumulativeData.caloriesInNum != 0 && cumulativeData.caloriesInNum != null)) ?
                                                                                <span className="small-text accDetail" tabindex="0" aria-label={cumulativeData.calories} > {cumulativeData.calories}</span>
                                                                                : ""}

                                                                        </p>
                                                                    </div>
                                                                </div>

                                                                <div className="modifierCust btn-lg-text form-check applebees-checkbox">
                                                                    <input className="rounded-circle form-check-input" type="radio" name="radioButton" aria-label="Radio" />
                                                                    <label for="radioButton" className="d-none" aria-label="Radio">Radio Button</label>
                                                                </div>
                                                                <div className="pdp-substitute-wrapper">

                                                                    <span className="p2 bold">{data.SubstituteTitle}</span>
                                                                    <span className="p2">{data.SubstituteDescription}</span>
                                                                    <span id={modifier.MenuItemDetail.Id + "-checkClick"} className="btn btn-text firstClick" onClick={(e) => { this.handleClickState(modifier.MenuItemDetail.Id, modifier, ModifierGroup); e.stopPropagation(); }} tabIndex="0"> {this.getSubstituteOptionGroupName(modifier.optionGroups)}</span>

                                                                </div>

                                                            </div>
                                                            :
                                                            (modifier.ComponentDisplay == 1) ?
                                                                <div className={this.getTileClass(modifier)}
                                                                    onClick={() => this.handleTileClick(modifier, ModifierGroup)}>
                                                                    {(productSideImage.image != "none" && productSideImage.image != undefined) &&
                                                                        <img className="ModifierImg" src={productSideImage.image} alt={productSideImage.altname}
                                                                            onError={(e) => { this.handleImageError(e) }} />
                                                                    }
                                                                    <div className="ModifierDesc">
                                                                        <div className="leftDesc">
                                                                            <p className="p2 ellipsisText">{modifier.MenuItemDetail.Name}</p>
                                                                            <p className="small-text accDetail ellipsisText">
                                                                                {this.getTileDescription(modifier.MenuItemDetail.Id, "", modifier.ComponentDisplay)}
                                                                            </p>

                                                                            <p className="p2">
                                                                                {(cumulativeData.calcPrice != 0) && <span className="addPrice small-text">+ {cumulativeData.price}</span>}
                                                                                {(modifier.MenuItemDetail.BaseCalories != null && modifier.MenuItemDetail.BaseCalories != "") ?
                                                                                    <span className="small-text accDetail" tabindex="0" aria-label={modifier.MenuItemDetail.BaseCalories} tabindex="0"> {this.getCalorieText(modifier.MenuItemDetail.BaseCalories)}&nbsp;{this.props.CalorieAbbr}</span> :
                                                                                    ""
                                                                                }
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                    <div className="modifierCust btn-lg-text form-check applebees-checkbox" >

                                                                        <div>
                                                                            <div id={modifier.MenuItemDetail.Id + "-checkClick"} onClick={
                                                                                (e) => { this.handleClickState(modifier.MenuItemDetail.Id, modifier, ModifierGroup); e.stopPropagation(); }} className="firstClick customIng"><u>{data.CustomizeButtonText}</u></div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                :
                                                                (modifier.ComponentDisplay == 5 && modifier.OptionDisplayStyle == "segmented") ?

                                                                    <div className={this.getTileClass(modifier)}
                                                                        onClick={() => this.handleTileClick(modifier, ModifierGroup)}
                                                                        tabIndex="0">
                                                                        {(productSideImage.image != "none" && productSideImage.image != undefined) &&
                                                                            <img className="ModifierImg" src={productSideImage.image} alt={productSideImage.altname}
                                                                                onError={(e) => { this.handleImageError(e) }} />
                                                                        }
                                                                        <div className="ModifierDesc">
                                                                            <div className="leftDesc">
                                                                                <p className="p2 ellipsisText"> {modifier.MenuItemDetail.Name} </p>

                                                                                <p className="p2">
                                                                                    {(cumulativeData.calcPrice !== 0) &&
                                                                                        <span className="addPrice small-text test1">+ {cumulativeData.price}</span>

                                                                                    }
                                                                                    {(this.props.idMaps && this.props.idMaps.has(modifier.MenuItemDetail.Id) && this.props.idMaps.get(modifier.MenuItemDetail.Id).length > 0) &&
                                                                                        <span className="small-text accDetail"
                                                                                            tabindex="0" aria-label={cumulativeData.calories} tabindex="0">
                                                                                            {cumulativeData.calories}</span>
                                                                                    }

                                                                                </p>
                                                                            </div>
                                                                        </div>
                                                                        <div className="modifierCust btn-lg-text form-check applebees-checkbox">
                                                                            <div className="customIng"><input className="rounded-circle form-check-input" type="radio" name="radioButton" aria-label="Radio" />
                                                                                <label for="radioButton" className="d-none" aria-label="Radio">Radio Button</label>
                                                                            </div>

                                                                            <div>


                                                                                {(!this.props.idMaps.has(modifier.MenuItemDetail.Id)) &&
                                                                                    <div>
                                                                                        <input className="rounded-circle form-check-input" type="radio" aria-label="Radio" />
                                                                                        <label className="d-none" aria-label="Radio">Radio Button</label>
                                                                                    </div>
                                                                                }

                                                                            </div>

                                                                        </div>
                                                                        {modifier.optionGroups[0] != undefined ?
                                                                            <div className="hrseparator">
                                                                                <div id={modifier.MenuItemDetail.Id + "-checkClick"}
                                                                                    onClick={(e) => {
                                                                                        e.stopPropagation();
                                                                                        this.handleSegmented(modifier.MenuItemDetail.Id, modifier.MenuItemDetail.Name, ModifierGroup.maxselects, ModifierGroup.Id, ModifierGroup.IsRequired, modifier.MenuItemDetail.Price, modifier.optionGroups[0].Modifiers, "Extra", modifier.MenuItemDetail.BaseCalories, modifier.MenuItemDetail.CalcPrice, modifier.ComponentDisplay)
                                                                                        
                                                                                    }}
                                                                                    tabIndex="0" type="button"
                                                                                    className={(this.checkItemIsAdded(modifier.optionGroups[0].Modifiers, "Extra") == true) ? "extraAdded extraClick" : " extraClick"} display="extra">

                                                                                    <span className="add-extra" tabIndex="-1">{data.AddextraText} {(extraPrice != "$0.00") && "+" + extraPrice}</span>
                                                                                    <span className="extra-added" tabIndex="-1">{data.ExtraaddedText} {(extraPrice != "$0.00") && "+" + extraPrice}</span>

                                                                                </div></div>
                                                                            : ""}
                                                                    </div>


                                                                    :

                                                                    <div className={this.getTileClass(modifier)}
                                                                        onClick={() => { this.handleTileClick(modifier, ModifierGroup) }} tabIndex="0">
                                                                        {(productSideImage.image != "none" && productSideImage.image != undefined) &&
                                                                            <img className="ModifierImg" src={productSideImage.image} alt={productSideImage.altname}
                                                                                onError={(e) => { this.handleImageError(e) }} />
                                                                        }
                                                                        <div className="ModifierDesc">
                                                                            <div className="leftDesc">
                                                                                <p className="p2 ellipsisText">{this.getTileName(modifier.MenuItemDetail, modifier.ComponentDisplay)}</p>

                                                                                <p className="small-text accDetail ellipsisText">
                                                                                    {this.getTileDescription(modifier.MenuItemDetail.Id, "", modifier.ComponentDisplay)}
                                                                                </p>
                                                                                <p className={"p2 " + cumulativeData.caloriesInNum}>
                                                                                    {(cumulativeData.calcPrice !== 0) &&
                                                                                        <span className="addPrice small-text test1">+ {cumulativeData.price}</span>
                                                                                    }
                                                                                    {((cumulativeData.caloriesInNum != 0 && cumulativeData.caloriesInNum != null)) &&
                                                                                        <span className="small-text accDetail"
                                                                                            tabindex="0" aria-label={cumulativeData.calories} tabindex="0">
                                                                                            {cumulativeData.calories}</span>
                                                                                    }
                                                                                </p>

                                                                            </div>
                                                                        </div>
                                                                        <div className="modifierCust btn-lg-text form-check applebees-checkbox"

                                                                            onClick={((modifier.ComponentDisplay == 6) ||(modifier.ComponentDisplay != 0 && modifier.ComponentDisplay != 2 && modifier.ComponentDisplay != 3 && modifier.ComponentDisplay != 4 &&
                                                                                    modifier.ComponentDisplay != 8 && modifier.ComponentDisplay != 6)) ?
                                                                                (e) => { this.handleClickState(modifier.MenuItemDetail.Id, modifier, ModifierGroup); e.stopPropagation(); } :
                                                                                ""}

                                                                            tabIndex={((modifier.ComponentDisplay == 6) || (modifier.ComponentDisplay != 0  && modifier.ComponentDisplay != 3 && modifier.ComponentDisplay != 4 &&
                                                                                modifier.ComponentDisplay != 8 && modifier.ComponentDisplay != 6)) ?
                                                                                ((modifier.ComponentDisplay != 0) ? "0" : "-1") : "-1"}>

                                                                            {(modifier.ComponentDisplay == 0 || modifier.ComponentDisplay == 3) ?
                                                                                ((this.props.idMaps.has(modifier.MenuItemDetail.Id) || multiSelect.indexOf(modifier.MenuItemDetail.Id) > -1) ?
                                                                                    <div><input tabIndex="-1" className="rounded-circle form-check-input" type="radio" name="radioButton" aria-label="Radio" /><label for="radioButton" className="d-none" aria-label="Radio">Radio Button</label></div> :
                                                                                    (modifier.ComponentDisplay == 5 && modifier.OptionDisplayStyle == "segmented") ?
                                                                                        <div><input tabIndex="-1"  className="rounded-circle form-check-input" type="radio" name="radioButton" aria-label="Radio" /><label for="radioButton" className="d-none" aria-label="Radio">Radio Button</label></div> :
                                                                                        "") :

                                                                                <div>


                                                                                    {(modifier.ComponentDisplay == 2)

                                                                                        && <div id={modifier.MenuItemDetail.Id + "-checkClick"} className="firstClick" display="gt"></div>}

                                                                                    {(modifier.ComponentDisplay == 4 && (!this.props.idMaps.has(modifier.MenuItemDetail.Id) ||
                                                                                        (this.props.idMaps.has(modifier.MenuItemDetail.Id) && this.props.idMaps.get(modifier.MenuItemDetail.Id).length <= 1))) &&
                                                                                        <div id={modifier.MenuItemDetail.Id + "-checkClick"} className="firstClick"><i className="bi bi-plus"></i></div>}
                                                                                    {(modifier.ComponentDisplay == 4 && (this.props.idMaps.has(modifier.MenuItemDetail.Id)) && (this.props.idMaps.get(modifier.MenuItemDetail.Id).length > 1)) &&
                                                                                        <div><input className="rounded-circle form-check-input" type="radio" aria-label="Radio" /><label className="d-none" aria-label="Radio">Radio Button</label></div>}
                                                                                    {modifier.ComponentDisplay == 8 && (!this.props.idMaps.has(modifier.MenuItemDetail.Id)) &&
                                                                                        <div><input className="rounded-circle form-check-input" type="radio" aria-label="Radio" /><label className="d-none" aria-label="Radio">Radio Button</label></div>}
                                                                                    {(modifier.ComponentDisplay == 6)
                                                                                        && <div id={modifier.MenuItemDetail.Id + "-checkClick"} display="change" className="customIng show firstClick"><u>{"Change"}</u></div>}
                                                                                    {((modifier.MenuItemDetail.IsDefault == true) && (modifier.ComponentDisplay != 6)) &&
                                                                                        <div><input className="rounded-circle form-check-input" type="radio" aria-label="Radio" /><label className="d-none" aria-label="Radio">Radio Button</label></div>}
                                                                                </div>
                                                                            }
                                                                        </div>
                                                                        {(modifier.ComponentDisplay == 3 && (this.props.idMaps.has(modifier.MenuItemDetail.Id) && this.filterDropDownInOption(modifier.optionGroups))) ?
                                                                            <div className="accDropdown-body">
                                                                                <div className="pdp-dropdown-wrapper pdp-dropdown-option">
                                                                                    <PdpDropdownModal data={this.state.DropdownDetails}
                                                                                        holdTempSelectedIds={(e, label, ids) => this.holdTempSelectedIds(e, label, ids)}
                                                                                        setSelectedModifiersList={(obj) => this.props.setSelectedModifiersList(obj)}
                                                                                        updateTotalPrice={(price, action, id) => this.props.updateTotalPrice(price, action, id)}
                                                                                        id={ModifierGroup.Id}
                                                                                        parentID={ModifierGroup.Id}
                                                                                        reqdStatus={ModifierGroup.IsRequired}
                                                                                        selectedModifiers={this.props.selectedModifiers}
                                                                                        parentModifierId={modifier.MenuItemDetail.Id}
                                                                                        errMsg={data.RequiredSelection}
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                            : ""}
                                                                    </div>
                                                        }
                                                    </div>
                                                )
                                            })}
                                        </div>
                                        :
                                        <div className="accordion" id={"#accordion-" + ModifierGroup.Id} aria-labelledby={ModifierGroup.Name}>
                                            <div className="accordion-item">
                                                <h5 className="accordion-header pdp-dropdown-header">
                                                    <button className={"accordion-button " + reqClass} data-option-title={ModifierGroup.Name} type="button" data-bs-toggle="collapse" aria-labelledby={ModifierGroup.Name} data-bs-target={"#accordion-" + ModifierGroup.Id} aria-expanded="false" aria-controls={"#accordion-" + ModifierGroup.Id}>
                                                        {ModifierGroup.Name}
                                                        <p className={"p2 scroller-bar " + reqiuredText.className} data-group-name={ModifierGroup.Name}> ({reqiuredText.text})</p>
                                                    </button>
                                                </h5>
                                            </div>
                                            {
                                                <div id={"accordion-" + ModifierGroup.Id} className="accordion-collapse collapse" aria-labelledby={ModifierGroup.Name} data-bs-parent={"#accordion-" + ModifierGroup.Id}>
                                                    <div className="accordion-body accDropdownGroup-body">
                                                        <div className="pdp-dropdown-wrapper">
                                                            <PdpDropdownGroupModal data={this.filterDropDownInOptionGroup(ModifierGroup)}
                                                                holdTempSelectedIds={(e, label, ids) => this.holdTempSelectedIdsDropDownGroup(e, label, ids)}
                                                                id={ModifierGroup.Id} reqdStatus={ModifierGroup.IsRequired}
                                                                updateTotalPrice={(price, action, id) => this.props.updateTotalPrice(price, action, id)} selectedModifiers={this.props.data != null ? this.props.data.SelectedChoices : null}
                                                                removeSelectedModifiersList={(obj, type, mid) => this.props.removeSelectedModifiersList(obj, type, mid)}
                                                                setSelectedModifiersList={(obj) => this.props.setSelectedModifiersList(obj)}
                                                                idMaps={this.props.idMaps}
                                                                errMsg={data.RequiredSelection}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            }

                                        </div>
                                )
                            }
                        })
                        }
                    </div>
                </div>
                <div className="overlay hidden"></div>
            </div>
        )
    }
}

